// extracted by mini-css-extract-plugin
module.exports = {"Headings":"Description_Headings__8EoaL","Text":"Description_Text__3aoTv","Navigation":"Description_Navigation__3zQgR","Icons":"Description_Icons__27SXz"};